import { render, staticRenderFns } from "./Voters.vue?vue&type=template&id=7f106a7f&scoped=true&"
import script from "./Voters.vue?vue&type=script&lang=ts&"
export * from "./Voters.vue?vue&type=script&lang=ts&"
import style0 from "./Voters.vue?vue&type=style&index=0&id=7f106a7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f106a7f",
  null
  
)

export default component.exports